import React from 'react';
import { N as NextHead } from './NextHead-828BS7ON.js';
import { E as ErrorPage } from './ErrorPage-hsjsOFEm.js';
import logger from './utils/logger.js';
import 'cookies-next';
import './currency-_kacFJHO.js';
import './language-BHHwgtQp.js';
import './payment-a4IKjS7g.js';
import './utils/currency.js';
import './context/index.js';
import 'lodash/get';
import './product-_pRduMz7.js';
import 'next/router';
import './helpers-WYINLSKJ.js';
import 'lodash';

const NextPage = ({ children, error, meta, headContent, siteUrl }) => (React.createElement(React.Fragment, null,
    React.createElement(NextHead, { meta: meta, content: headContent, siteUrl: siteUrl }),
    error ? React.createElement(ErrorPage, { error: error, logger: logger }) : children));

export { NextPage as N };
//# sourceMappingURL=NextPage-bfoe9alf.js.map
